import React, { useState } from 'react'
import { Button } from '@ow/comps'

export default ({ prefix, isRegister, disable, loginCodeApi }) => {
  const [sending, setSending] = useState(false)
  const [reSendingSec, setReSendingSec] = useState(1800)

  const countDown = () => {
    let sec = 60
    setReSendingSec(60)
    let timer = setInterval(() => {
      if (sec === 0) {
        setSending(false)
        clearTimeout(timer)
        timer = null
      } else {
        setReSendingSec(sec)
        sec--
      }
    }, 1000)
  }

  return (
    <Button
      className={`${prefix}-codeBtn`}
      disabled={disable}
      onClick={() => {
        if (!sending) {
          loginCodeApi(isRegister ? 1 : 2).then((data) => {
            console.log(data, 'data')
            setSending(true)
            countDown()
          })
        }
      }}
    >
      {sending ? `${reSendingSec}s后重发` : `获取验证码`}
    </Button>
  )
}
